module.exports = __webpack_public_path__ + "static/media/hotelmontefiore.aa918c1f.jpg";